import { useState, useEffect } from "react";
import { BodyWithClass, Btn } from "@client/ui";
import { useNavigate } from "react-router-dom";

const BusinessHeroSection: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const businessTypes = [
    {
      type: "Corporate Events",
      image: "/image/corporate-events.jpg",
      description:
        "Reliable food delivery for meetings, conferences, and corporate events.",
    },
    {
      type: "Office Catering",
      image: "/image/office-catering.jpg",
      description:
        "Streamline lunch orders and team meals with our business-focused solutions.",
    },
    {
      type: "Retail Shops",
      image: "/image/retail-shop.jpg",
      description:
        "Provide local delivery for your retail customers with our flexible options.",
    },
    {
      type: "Hotels & Hospitality",
      image: "/image/hotel.jpg",
      description:
        "Enhance guest experience with reliable delivery to rooms and event spaces.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % businessTypes.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, [businessTypes.length]);

  const navigateToBusinessPage = () => {
    navigate("/business-solutions");
  };

  return (
    <div className="bg-background-light max-w-full w-[700px] m-auto py-8 px-4 rounded-[12px] mb-[50px]">
      <BodyWithClass
        className="font-primary text-[24px] text-center font-semibold"
        text="Business Solutions by Tapzus"
      />
      <div className="mt-4 text-center">
        <BodyWithClass
          className="hero-section text-[20px] font-medium"
          text="Streamline deliveries for your business"
        />
        <BodyWithClass
          className="additional-text text-[18px] text-gray-600 mt-2"
          text="From corporate catering to retail delivery, Tapzus offers specialized solutions to meet your business needs."
        />
        <BodyWithClass
          className="benefits-text text-[16px] text-gray-500 mt-4"
          text="Increase efficiency, reduce costs, and improve customer satisfaction with our business-focused delivery options."
        />
      </div>

      <div className="w-full border-primary border-t-1 mt-6 pt-[30px]">
        <BodyWithClass
          className="image-text text-[20px] font-medium text-center mb-4"
          text="Solutions for every business type"
        />

        {/* Image carousel */}
        <div className="relative h-[300px] overflow-hidden rounded-lg shadow-md">
          {/* Images with fade transition */}
          {businessTypes.map((business, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 flex flex-col ${
                index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
              }`}
            >
              <div className="relative h-[220px] overflow-hidden">
                <img
                  src={business.image}
                  alt={business.type}
                  className="w-full h-full object-cover transition-transform duration-700 ease-in-out transform hover:scale-105"
                />
                <div className="absolute top-0 left-0 bg-gradient-to-r from-purple-900/70 to-transparent px-4 py-2 rounded-br-lg">
                  <h3 className="text-white font-bold text-lg">
                    {business.type}
                  </h3>
                </div>
              </div>
              <div className="bg-white p-4 h-[80px] flex items-center justify-center">
                <p className="text-center text-gray-700">
                  {business.description}
                </p>
              </div>
            </div>
          ))}

          {/* Indicator dots */}
          <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
            {businessTypes.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-colors ${
                  index === currentIndex ? "bg-purple-600" : "bg-gray-300"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="mt-8 text-center">
        <Btn
          text="Explore Business Solutions"
          onClick={navigateToBusinessPage}
          style={{
            backgroundColor: "#7e22ce",
            color: "white",
            padding: "10px 24px",
            borderRadius: "8px",
            fontWeight: "600",
          }}
        />
      </div>
    </div>
  );
};

export default BusinessHeroSection;
